// YUVARAJ

import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Modal,
  Button,
  Table,
  Pagination,
  Form,
  InputGroup,
  Row,
  Col,
  Dropdown,
} from "react-bootstrap";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { showMyAlert } from "../../Utils/alertService";

const AddSalary = () => {
  const [employees, setEmployees] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [salaryHistory, setSalaryHistory] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [salarySets, setSalarySets] = useState([]);
  const [showAllHistory, setShowAllHistory] = useState(false);
  const [employeeDetails, setEmployeeDetails] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // Filter and search states
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedShift, setSelectedShift] = useState("");
  const [locations, setLocations] = useState([]);
  const [shifts, setShifts] = useState([]);

  const companyKey = sessionStorage.getItem("companyKey");

  // Get user role from session storage
  const userRole = sessionStorage.getItem("role");

  // Helper function to safely parse JSON
  const safeJsonParse = (jsonString, defaultValue = null) => {
    try {
      if (!jsonString || jsonString.trim() === "") {
        return defaultValue;
      }
      return JSON.parse(jsonString);
    } catch (error) {
      console.error("JSON parsing error:", error, "Raw data:", jsonString);
      return defaultValue;
    }
  };

  // Function to log history
  const logHistory = async (action, oldData, newData, employee) => {
    try {
      const historyRecord = {
        performedById: sessionStorage.getItem("userId"),
        performedByName: sessionStorage.getItem("userName"),
        role: userRole,
        mobileNumber: sessionStorage.getItem("userMobile"),
        editDate: new Date().toISOString(),
        type: "ADD_SALARY",
        action: action,
        oldData: JSON.stringify(oldData),
        newData: JSON.stringify(newData),
        employeeId: employee.employee_id,
        employeeName: employee.full_name,
        companyKey,
      };

      await axios.post(
        "https://api.dremerz.net/api/DZ_8922_PayrollProduct_PayrollProductHistory_PayrollProductHistoryRecord",
        historyRecord
      );
    } catch (error) {
      console.error("Error logging history:", error);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    const keysToCheck = ["userId", "role", "userMobile", "userName"];

    const isDataMissing = keysToCheck.some((key) => {
      const localData = localStorage.getItem(key);
      const sessionData = sessionStorage.getItem(key);
      return !localData && !sessionData;
    });

    if (isDataMissing) {
      navigate(`/`);
    }
  }, [navigate]);

  // Fetch employee data
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch registered users
        const [usersResponse, detailsResponse] = await Promise.all([
          axios.get(
            "https://api.dremerz.net/api/DZ_8922_Payroll_PayrollRegistration_PayrollRegistrationUsers"
          ),
          axios.get(
            "https://api.dremerz.net/api/DZ_8922_Payroll_PayrollEmployeeBasicDetails_PayrollEmployeeDetails"
          ),
        ]);

        setEmployeeDetails(detailsResponse.data);

        const activeEmployees = usersResponse.data.filter(
          (emp) => emp.approval_status === "true"
        );
        setEmployees(activeEmployees);

        // Extract unique locations and shifts
        const uniqueLocations = [
          ...new Set(activeEmployees.map((emp) => emp.locationName)),
        ].filter(Boolean);
        setLocations(uniqueLocations);

        const allShifts = activeEmployees.flatMap((emp) => {
          const empShifts = safeJsonParse(emp.shift, []);
          return empShifts.map((s) => s.shiftName);
        });
        const uniqueShifts = [...new Set(allShifts)].filter(Boolean);
        setShifts(uniqueShifts);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // // Fetch attendance data
  // useEffect(() => {
  //   const fetchAttendanceData = async () => {
  //     try {
  //       const response = await axios.get(
  //         "https://api.dremerz.net/api/DZ_8922_EmpAttendance_EmpAttendanceDetails_AttendanceHistory"
  //       );
  //       setAttendanceData(response.data);
  //     } catch (error) {
  //       console.error("Error fetching attendance data:", error);
  //     }
  //   };

  //   fetchAttendanceData();
  // }, []);

  // Fetch salary history
  useEffect(() => {
    const fetchSalaryHistory = async () => {
      try {
        const response = await axios.get(
          "https://api.dremerz.net/api/DZ_8924_Payroll_PayrollSalaryCalculation_PayrollAddSalary_PayrollSalaryList"
        );
        setSalaryHistory(response.data);
      } catch (error) {
        console.error("Error fetching salary history:", error);
      }
    };

    fetchSalaryHistory();
  }, []);

  const handleProcessSalary = (employee) => {
    setSelectedEmployee(employee);
    calculateSalarySets(employee);
    setShowModal(true);
  };

  // Check if employee is approved in EmployeeDetails
  const isEmployeeApproved = (employee) => {
    if (!employee || !employeeDetails.length) return false;

    const detail = employeeDetails.find(
      (detail) => detail.userId === employee.id
    );

    return detail ? detail.approvalStatus === "true" : false;
    // return true;
  };

  const calculateSalarySets = (employee) => {
    const sets = [];
    const today = moment();

    // Parse employee data with error handling
    const salaryData = safeJsonParse(employee.salary, []);
    const overTimeSalaryData = safeJsonParse(employee.overTimeSalary, []);

    if (!salaryData || salaryData.length === 0) {
      console.error("No salary data found for employee:", employee.employee_id);
      setSalarySets([]);
      return;
    }

    const latestSalary = salaryData.sort(
      (a, b) => new Date(b.dateAdded) - new Date(a.dateAdded)
    )[0];

    const latestOverTimeSalary = overTimeSalaryData.sort(
      (a, b) => new Date(b.dateAdded) - new Date(a.dateAdded)
    )[0];

    if (!latestSalary) {
      console.error(
        "No valid salary data found for employee:",
        employee.employee_id
      );
      setSalarySets([]);
      return;
    }

    const approvalDate = moment(employee.approval_date, "DD-MM-YYYY");
    const periodType = parseInt(employee.periodType) || 0;
    const payDate = employee.payDate ? moment(employee.payDate) : null;

    // Get employee attendance
    const empAttendance = attendanceData.filter(
      (att) => att.userMobile === employee.mobile_number
    );

    if (periodType > 0) {
      // Calculate sets based on periodType
      let currentStart = approvalDate.clone();

      while (currentStart.isBefore(today)) {
        const currentEnd = currentStart.clone().add(periodType - 1, "days");
        const isComplete = currentEnd.isBefore(today);

        const setData = {
          startDate: currentStart.format("YYYY-MM-DD"),
          endDate: currentEnd.format("YYYY-MM-DD"),
          status: isComplete ? "completed" : "onProcess",
          periodType: periodType,
        };

        // Calculate working hours for this set
        if (isComplete) {
          const { workingDays, totalHours, overTimeHours } =
            calculateWorkingHours(empAttendance, currentStart, currentEnd);

          setData.workingDays = workingDays;
          setData.totalWorkingHours = totalHours;
          setData.overTimeHours = overTimeHours;

          // Calculate salary
          if (latestSalary.salaryType === "hourly") {
            const hours = parseHoursToDecimal(totalHours);
            const regularSalary = (hours * latestSalary.amount).toFixed(2);

            // Calculate overtime salary if overtime exists
            let overtimeSalary = 0;
            if (overTimeHours && latestOverTimeSalary) {
              const overtimeHours = parseHoursToDecimal(overTimeHours);
              overtimeSalary = (
                overtimeHours * latestOverTimeSalary.amount
              ).toFixed(2);
            }

            setData.calculatedSalary = regularSalary;
            setData.overtimeSalary = overtimeSalary;
            setData.totalSalary = (
              parseFloat(regularSalary) + parseFloat(overtimeSalary)
            ).toFixed(2);
          } else {
            // For fixed salary, no overtime calculation
            setData.calculatedSalary = latestSalary.amount;
            setData.overtimeSalary = "0.00";
            setData.totalSalary = latestSalary.amount;
          }

          // Check if already paid
          const isPaid = salaryHistory.some(
            (sh) =>
              sh.employee_id === employee.employee_id &&
              sh.endDate === setData.endDate
          );

          setData.isPaid = isPaid;
        }

        sets.unshift(setData); // Add to beginning to show latest first
        currentStart = currentEnd.clone().add(1, "day");
      }
    } else if (payDate) {
      // Calculate sets based on payDate
      let currentEnd = payDate.clone();

      if (currentEnd.date() > today.date()) {
        currentEnd.subtract(1, "month");
      }

      while (
        currentEnd.isAfter(approvalDate) ||
        currentEnd.isSame(approvalDate)
      ) {
        const currentStart = currentEnd
          .clone()
          .subtract(1, "month")
          .add(1, "day");
        const isComplete = currentEnd.isBefore(today);

        const setData = {
          startDate: currentStart.format("YYYY-MM-DD"),
          endDate: currentEnd.format("YYYY-MM-DD"),
          status: isComplete ? "completed" : "onProcess",
          payDate: payDate.date(),
        };

        // Calculate working hours for this set
        if (isComplete) {
          const { workingDays, totalHours, overTimeHours } =
            calculateWorkingHours(empAttendance, currentStart, currentEnd);

          setData.workingDays = workingDays;
          setData.totalWorkingHours = totalHours;
          setData.overTimeHours = overTimeHours;

          // Calculate salary
          if (latestSalary.salaryType === "hourly") {
            const hours = parseHoursToDecimal(totalHours);
            const regularSalary = (hours * latestSalary.amount).toFixed(2);

            // Calculate overtime salary if overtime exists
            let overtimeSalary = 0;
            if (overTimeHours && latestOverTimeSalary) {
              const overtimeHours = parseHoursToDecimal(overTimeHours);
              overtimeSalary = (
                overtimeHours * latestOverTimeSalary.amount
              ).toFixed(2);
            }

            setData.calculatedSalary = regularSalary;
            setData.overtimeSalary = overtimeSalary;
            setData.totalSalary = (
              parseFloat(regularSalary) + parseFloat(overtimeSalary)
            ).toFixed(2);
          } else {
            // For fixed salary, no overtime calculation
            setData.calculatedSalary = latestSalary.amount;
            setData.overtimeSalary = "0.00";
            setData.totalSalary = latestSalary.amount;
          }

          // Check if already paid
          const isPaid = salaryHistory.some(
            (sh) =>
              sh.employee_id === employee.employee_id &&
              sh.endDate === setData.endDate
          );

          setData.isPaid = isPaid;
        }

        sets.unshift(setData); // Add to beginning to show latest first
        currentEnd = currentStart.clone().subtract(1, "day");
      }
    }

    setSalarySets(sets);
  };

  const calculateWorkingHours = (attendance, startDate, endDate) => {
    const daysInSet = [];
    let currentDate = startDate.clone();

    while (currentDate.isSameOrBefore(endDate)) {
      daysInSet.push(currentDate.format("D-M-YYYY"));
      currentDate.add(1, "day");
    }

    let workingDays = 0;
    let totalHours = "0h 0m";
    let overTimeHours = "0h 0m";
    let totalMinutes = 0;
    let overTimeMinutes = 0;

    daysInSet.forEach((day) => {
      // Find attendance for this day
      const dayAttendance = attendance.filter((att) => att.date === day);

      if (dayAttendance.length > 0) {
        // Find completed records first
        let record = dayAttendance.find((att) => att.status === "completed");

        if (!record) {
          // If no completed, find permitted-out records (latest one)
          const permittedOut = dayAttendance.filter(
            (att) => att.status === "permitted-out"
          );
          if (permittedOut.length > 0) {
            record = permittedOut.sort(
              (a, b) => new Date(b.checkoutTime) - new Date(a.checkoutTime)
            )[0];
          }
        }

        if (record) {
          if (record.total_workingHours) {
            workingDays++;
            const [hours, mins] = record.total_workingHours
              .split("h ")
              .map(
                (part) => parseInt(part.replace("h", "").replace("m", "")) || 0
              );
            totalMinutes += hours * 60 + mins;
          }

          if (record.overTimeHours) {
            const [otHours, otMins] = record.overTimeHours
              .split("h ")
              .map(
                (part) => parseInt(part.replace("h", "").replace("m", "")) || 0
              );
            overTimeMinutes += otHours * 60 + otMins;
          }
        }
      }
    });

    // Convert total minutes back to "Xh Ym" format
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    totalHours = `${hours}h ${minutes}m`;

    // Convert overtime minutes
    const otHours = Math.floor(overTimeMinutes / 60);
    const otMinutes = overTimeMinutes % 60;
    overTimeHours = `${otHours}h ${otMinutes}m`;

    return { workingDays, totalHours, overTimeHours };
  };

  const parseHoursToDecimal = (timeStr) => {
    if (!timeStr) return 0;
    const [hours, minutes] = timeStr
      .split("h ")
      .map((part) => parseInt(part.replace("h", "").replace("m", "")) || 0);
    return hours + minutes / 60;
  };

  const addTimeStrings = (timeStr1, timeStr2) => {
    const parse = (str) => {
      const [hoursStr, minutesStr] = str.split("h ");
      const hours = parseInt(hoursStr.replace("h", ""), 10) || 0;
      const minutes = parseInt(minutesStr?.replace("m", ""), 10) || 0;
      return { hours, minutes };
    };

    const t1 = parse(timeStr1 || "0h 0m");
    const t2 = parse(timeStr2 || "0h 0m");

    let totalMinutes = t1.minutes + t2.minutes;
    let totalHours = t1.hours + t2.hours + Math.floor(totalMinutes / 60);
    totalMinutes = totalMinutes % 60;

    return `${totalHours}h ${totalMinutes}m`;
  };

  const handlePaySalary = async (setData) => {
    try {
      const salaryData = safeJsonParse(selectedEmployee.salary, []);
      const overTimeSalaryData = safeJsonParse(
        selectedEmployee.overTimeSalary,
        []
      );

      if (!salaryData || salaryData.length === 0) {
        showMyAlert({
          type: "info", // "success" | "danger" | "warning" | "info"
          title: "Info",
          message: "Employee salary data in not available",
          duration: 2500, // auto-close in 2.5s
        });
        return;
      }

      const latestSalary = salaryData.sort(
        (a, b) => new Date(b.dateAdded) - new Date(a.dateAdded)
      )[0];

      const latestOverTimeSalary = overTimeSalaryData.sort(
        (a, b) => new Date(b.dateAdded) - new Date(a.dateAdded)
      )[0];

      const payload = {
        userId: selectedEmployee.id,
        userName: selectedEmployee.full_name,
        employee_id: selectedEmployee.employee_id,
        email: selectedEmployee.email || "",
        mobileNumber: selectedEmployee.mobile_number,
        workingDays: setData.workingDays.toString(),
        salaryType: latestSalary.salaryType,
        overTimeRate: latestOverTimeSalary ? latestOverTimeSalary.amount : "0",
        regularRate: latestSalary.amount,
        createdAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        startDate: setData.startDate,
        endDate: setData.endDate,
        normaltotalWorkingHours: setData.totalWorkingHours,
        ottotalWorkingHours: setData.overTimeHours || "0h 0m",
        overalltotalWorkingHours: addTimeStrings(
          setData.totalWorkingHours,
          setData.overTimeHours
        ),
        normalcalculatedSalary: setData.calculatedSalary,
        otcalculatedSalary: setData.overtimeSalary || "0.00",
        overallcalculatedSalary: setData.totalSalary,
        companyKey,
      };

      // Log the action before making the payment
      await logHistory(
        "ADD_SALARY",
        "", // No old data for new payment
        payload,
        selectedEmployee
      );

      await axios.post(
        "https://api.dremerz.net/api/DZ_8924_Payroll_PayrollSalaryCalculation_PayrollAddSalary_PayrollSalaryList",
        payload
      );

      // Refresh salary history
      const response = await axios.get(
        "https://api.dremerz.net/api/DZ_8924_Payroll_PayrollSalaryCalculation_PayrollAddSalary_PayrollSalaryList"
      );
      setSalaryHistory(response.data);

      // Update the current set to mark as paid
      const updatedSets = salarySets.map((set) => {
        if (set.endDate === setData.endDate) {
          return { ...set, isPaid: true };
        }
        return set;
      });
      setSalarySets(updatedSets);

      showMyAlert({
        type: "success", // "success" | "danger" | "warning" | "info"
        title: "Success",
        message: "Salary paid successfully",
        duration: 2500, // auto-close in 2.5s
      });
    } catch (error) {
      console.error("Error paying salary:", error);
      if (error.response) {
        console.error("Server response:", error.response.data);
        showMyAlert({
          type: "danger", // "success" | "danger" | "warning" | "info"
          title: "Failed",
          message:
            "Server error: " +
            (error.response.data?.message || "Unknown error"),
          duration: 2500, // auto-close in 2.5s
        });
      } else {
        showMyAlert({
          type: "danger", // "success" | "danger" | "warning" | "info"
          title: "Failed",
          message: "Failed to Pay salary, please try again later",
          duration: 2500, // auto-close in 2.5s
        });
      }
    }
  };

  const renderShiftInfo = (shiftJson) => {
    const shifts = safeJsonParse(shiftJson, []);
    if (shifts && shifts.length > 0) {
      return shifts[0].shiftName || "N/A";
    }
    return "N/A";
  };

  const getSalaryDisplay = (employee) => {
    const salaryData = safeJsonParse(employee.salary, []);
    const overTimeSalaryData = safeJsonParse(employee.overTimeSalary, []);

    if (!salaryData || salaryData.length === 0) {
      return "No salary data";
    }

    const latestSalary = salaryData.sort(
      (a, b) => new Date(b.dateAdded) - new Date(a.dateAdded)
    )[0];

    const latestOverTimeSalary = overTimeSalaryData.sort(
      (a, b) => new Date(b.dateAdded) - new Date(a.dateAdded)
    )[0];

    if (!latestSalary) {
      return "No salary data";
    }

    let displayText =
      latestSalary.salaryType === "hourly"
        ? `${latestSalary.amount}/hour`
        : `Fixed: ${latestSalary.amount}`;

    if (latestOverTimeSalary) {
      displayText += ` | OT: ${latestOverTimeSalary.amount}/hour`;
    }

    return displayText;
  };

  const getPaymentTermText = (employee) => {
    if (employee.periodType && parseInt(employee.periodType) > 0) {
      return `Payment every ${employee.periodType} days`;
    } else if (employee.payDate) {
      return `Monthly payment on ${moment(employee.payDate).format("Do")}`;
    }
    return "No payment term specified";
  };

  // Filter employees based on search term and selected filters
  const filteredEmployees = employees.filter((employee) => {
    // Search term filter
    const matchesSearch =
      employee.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.employee_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.mobile_number?.includes(searchTerm) ||
      employee.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.locationName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      renderShiftInfo(employee.shift)
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase());

    // Location filter
    const matchesLocation =
      !selectedLocation || employee.locationName === selectedLocation;

    // Shift filter
    const matchesShift =
      !selectedShift || renderShiftInfo(employee.shift) === selectedShift;

    return matchesSearch && matchesLocation && matchesShift;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRecords = filteredEmployees.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    setTotalPages(totalPages);

    // Reset to page 1 if current page exceeds total pages after items per page change
    if (currentPage > totalPages) {
      setCurrentPage(1);
    }
  }, [filteredEmployees, itemsPerPage, currentPage]);

  const handleItemsPerPageChange = (count) => {
    setItemsPerPage(count);
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  return (
    <div className="container-fluid px-5 py-5">
      <h2 className="mb-4">Employee Salary Processing</h2>

      {/* Search and Filter Section */}
      <div className="mb-4 p-3 border rounded bg-light">
        <Row>
          <Col md={6}>
            <Form.Group controlId="searchTerm">
              <Form.Label>Search Employees</Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search by name, ID, mobile, email, location or shift"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <InputGroup.Text>
                  <i className="bi bi-search"></i>
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="locationFilter">
              <Form.Label>Filter by Location</Form.Label>
              <Form.Select
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
              >
                <option value="">All Locations</option>
                {locations.map((location, index) => (
                  <option key={index} value={location}>
                    {location}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="shiftFilter">
              <Form.Label>Filter by Shift</Form.Label>
              <Form.Select
                value={selectedShift}
                onChange={(e) => setSelectedShift(e.target.value)}
              >
                <option value="">All Shifts</option>
                {shifts.map((shift, index) => (
                  <option key={index} value={shift}>
                    {shift}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </div>

      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            <th>Employee Name</th>
            <th>Employee ID</th>
            <th>Mobile Number</th>
            <th>Email</th>
            <th>Location</th>
            <th>Shift</th>
            <th>Approval Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.length > 0 ? (
            currentRecords.map((employee) => (
              <tr key={employee.id}>
                <td>{employee.full_name}</td>
                <td>{employee.employee_id}</td>
                <td>{employee.mobile_number}</td>
                <td>{employee.email || "N/A"}</td>
                <td>{employee.locationName}</td>
                <td>{renderShiftInfo(employee.shift)}</td>
                <td>{employee.approval_date}</td>
                <td>
                  <Button
                    variant="primary"
                    onClick={() => handleProcessSalary(employee)}
                  >
                    Process Salary
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                No employees found matching your criteria
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {filteredEmployees.length > 0 && (
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div className="d-flex align-items-center gap-2">
            <div>
              Showing {indexOfFirstItem + 1} to{" "}
              {Math.min(indexOfLastItem, filteredEmployees.length)} of{" "}
              {filteredEmployees.length} entries
            </div>
            <Dropdown>
              <Dropdown.Toggle
                variant="outline-primary"
                id="items-per-page-dropdown"
              >
                Show: {itemsPerPage}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {[5, 10, 20, 50, 100].map((count) => (
                  <Dropdown.Item
                    key={count}
                    onClick={() => handleItemsPerPageChange(count)}
                    active={itemsPerPage === count}
                  >
                    {count}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <Pagination>
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            />

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </Pagination.Item>
            ))}

            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            />
            <Pagination.Last
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        </div>
      )}

      {/* Salary Calculation Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            Salary Calculation for {selectedEmployee?.full_name} (
            {selectedEmployee?.employee_id})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEmployee && (
            <div>
              <div className="d-flex justify-content-between">
                <div>
                  <h5>Current Salary: </h5>
                  <p>{getSalaryDisplay(selectedEmployee)}</p>
                </div>
                <div>
                  <h5>Payment Term: </h5>
                  <p>{getPaymentTermText(selectedEmployee)}</p>
                </div>
              </div>

              {/* Approval status warning */}
              {!isEmployeeApproved(selectedEmployee) && (
                <div className="alert alert-warning small">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  This employee is not approved in the Employee Details system.
                  Salary cannot be paid until they are approved.
                </div>
              )}

              <h5 className="mt-4">Salary Sets:</h5>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Period</th>
                    <th>Working Days</th>
                    <th>Work Hours</th>
                    <th>Overtime Hours</th>
                    <th>Overall Hours</th>
                    <th>Regular Salary</th>
                    <th>Overtime Salary</th>
                    <th>Total Salary</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {salarySets
                    .slice(0, showAllHistory ? salarySets.length : 5)
                    .map((set, index) => {
                      const salaryData = safeJsonParse(
                        selectedEmployee.salary,
                        []
                      );
                      const latestSalary =
                        salaryData.length > 0
                          ? salaryData.sort(
                              (a, b) =>
                                new Date(b.dateAdded) - new Date(a.dateAdded)
                            )[0]
                          : null;

                      // Check if salary is 0 or invalid
                      const isZeroSalary =
                        parseFloat(set.totalSalary || 0) <= 0;

                      // Check if employee is approved
                      const isApproved = isEmployeeApproved(selectedEmployee);

                      return (
                        <tr key={index}>
                          <td>
                            {moment(set.startDate).format("DD-MM-YYYY")} to{" "}
                            {moment(set.endDate).format("DD-MM-YYYY")}
                          </td>
                          <td>{set.workingDays || "-"}</td>
                          <td>{set.totalWorkingHours || "-"}</td>
                          <td>{set.overTimeHours || "0h 0m"}</td>
                          <td>
                            {addTimeStrings(
                              set.totalWorkingHours,
                              set.overTimeHours
                            )}
                          </td>
                          <td>
                            {set.calculatedSalary
                              ? `₹${set.calculatedSalary}`
                              : "-"}
                          </td>
                          <td>
                            {set.overtimeSalary
                              ? `₹${set.overtimeSalary}`
                              : "₹0.00"}
                          </td>
                          <td>
                            {set.totalSalary ? `₹${set.totalSalary}` : "-"}
                          </td>
                          <td>
                            {set.status === "onProcess" ? (
                              <span className="text-warning">In Progress</span>
                            ) : set.isPaid ? (
                              <span className="text-success">Paid</span>
                            ) : isZeroSalary ? (
                              <span className="text-danger">No Earnings</span>
                            ) : !isApproved ? (
                              <span className="text-danger">Not Approved</span>
                            ) : (
                              <span className="text-primary">Pending</span>
                            )}
                          </td>
                          <td>
                            {set.status === "completed" && !set.isPaid && (
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => handlePaySalary(set)}
                                disabled={isZeroSalary || !isApproved}
                                title={
                                  isZeroSalary
                                    ? "No salary to pay for this period"
                                    : !isApproved
                                    ? "Employee not approved in Employee Details"
                                    : ""
                                }
                              >
                                Pay Salary
                              </Button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>

              {salarySets.length > 5 && (
                <Button
                  variant="link"
                  onClick={() => setShowAllHistory(!showAllHistory)}
                >
                  {showAllHistory ? "Show Less" : "Show All History"}
                </Button>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddSalary;
